var _circle, _circle2, _circle3, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMypoints(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 240,
    viewBox: "0 0 242 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 120,
    r: 96,
    stroke: "black",
    strokeWidth: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 119.5,
    r: 71.5,
    stroke: "black",
    strokeWidth: 10
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 120,
    r: 18,
    stroke: "black",
    strokeWidth: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    width: 10,
    height: 85,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 155,
    width: 10,
    height: 85,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 156.5,
    y: 125,
    width: 10,
    height: 85,
    transform: "rotate(-90 156.5 125)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 125,
    width: 10,
    height: 85,
    transform: "rotate(-90 0.5 125)",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypoints);
export default __webpack_public_path__ + "static/media/mypoints.f4cfdc7510728600dd2909b6fbb28427.svg";
export { ForwardRef as ReactComponent };